const Cookies = require("js-cookie");
const videos = document.querySelectorAll(
	".m-youtube-embed__thumbnail[data-video-id]"
);
const buttons = document.querySelectorAll(".m-youtube-embed__button");

function initVideos() {
	function createIframe(id) {
		const iframe = document.createElement("iframe");
		// <iframe width="560" height="315" src="https://www.youtube.com/embed/KT3XKDBZW7M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		iframe.src = `https://www.youtube.com/embed/${id}`;
		iframe.allowfullscreen = true;
		iframe.allow =
			"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
		return iframe;
	}

	function enableVideo(id, container) {
		const iframe = createIframe(id);
		container.innerHTML = "";
		container.classList.add("is-playing");
		container.appendChild(iframe);
	}

	videos.forEach((video) => {
		const id = video.dataset.videoId;
		const container = video.parentNode;

		enableVideo(id, container);
	});
}

function initCivicButtonActions() {
	setTimeout(function () {
		const acceptAllButton = document.getElementById("ccc-recommended-settings");

		if (acceptAllButton) {
			acceptAllButton.addEventListener("click", initVideos);
		}
	}, 500);
}

const cookieControl = Cookies.get("CookieControl");

if (cookieControl) {
	if (hasIabConsent() && videos.length) {
		initVideos();
	}
}

if (buttons.length) {
	buttons.forEach((button) => {
		button.addEventListener("click", function () {
			document.getElementById("ccc-icon").click();
			initCivicButtonActions();
		});
	});
}

document.addEventListener("DOMContentLoaded", initCivicButtonActions);
